<div class="wrappers1">
  <app-header></app-header>

  <div class="content">

    <app-menu></app-menu>
    <div class="row col-md-12 p-2 justify-content-center">
      <div class="col-md-7">
        <div class="mt-5">
          <!-- <div class="firstshift">Welcome Back! Let’s Continue Your Search</div> -->
          <!-- <div class="firstshift">Properties to buy in {{showcityname}}</div><br> -->
          <div class="containerthiss">

            <div>Every <span
                style="color: #004aad; font-weight: 600; font-family: ui-rounded;">Rental</span>
              has a Story, Start yours <span
                style="color: #004aad; font-weight: 600; font-family: ui-rounded;">Here</span>
            </div>

          </div><br>
          <!-- <div class="radio-groups">
            <label class="radio-option">
              <input type="radio" name="choice" value="buy" checked />
              Buy
            </label>
            <label class="radio-option">
              <input type="radio" name="choice" value="rent" />
              Rent
            </label>
          </div> -->
        </div>
        <div class="mt-3 tabpropease"
          style="background-color: #004aad; padding: 5px 15px; color: #ffffff; border-radius: 20px 20px 0 0;">
          <mat-tab-group (selectedTabChange)="onTabChange($event)"
            class="white-tabs">
            <mat-tab *ngFor="let tab of tabs" [label]="tab.name"></mat-tab>
          </mat-tab-group>
        </div>
        <!-- Search Bar Container -->
        <div class="custom-search">
          <div class="row align-items-center w-100 m-0 px-3">
            <div class="col-md-3">
              <label class="field-label">Location</label>

              <div class="position-relative">
                <input type="text"
                  class="form-control city-input"
                  style="cursor: pointer;"
                  [(ngModel)]="searchCityQuery"
                  (keyup)="searchCity(searchCityQuery)"
                  (click)="onCityInputClick()"
                  (focus)="onCityInputClick()"
                  (blur)="hideCitySuggestions()"
                  [placeholder]="selectedCityName ? selectedCityName : 'Search City...'"
                  #cityInput />

                <i *ngIf="!showCitySuggestions || cityDataList.length === 0"
                  class="fa fa-chevron-down dropdown-icon"
                  (mousedown)="$event.preventDefault(); openCitySuggestions()">
                </i>

                <!-- Chevron Up: only shown when dropdown is open -->
                <i *ngIf="showCitySuggestions && cityDataList.length > 0"
                  class="fa fa-chevron-up dropdown-icon"
                  (mousedown)="$event.preventDefault(); closeCitySuggestions()">
                </i>

                <ul *ngIf="shouldShowCitySuggestions"
                  class="suggestion-dropdownss">
                  <li *ngFor="let city of cityDataList"
                    (mousedown)="selectCity(city)"
                    [class.selected]="city.id === selectedCityId">
                    {{ city.name }}
                  </li>
                </ul>
              </div>

            </div>

            <!-- Locality Block -->
            <div class="col-md-4 border-left-custom">
              <label class="field-label">Locality</label>
              <div class="position-relative">
                <input type="text" #searchkey class="form-control search-input"
                  [(ngModel)]="searchQuery"
                  (keyup)="onclickSearch()" (click)="onclickSearch()"
                  (blur)="hideSuggestions()"
                  placeholder="Search locality" />
                <i class="fa fa-map-marker-alt location-icon"
                  style="cursor: pointer;"
                  (click)="onIconClickloc(searchkey)"></i>
                <ul *ngIf="showSuggestions && areaList?.length > 0"
                  class="suggestion-dropdown">
                  <li *ngFor="let area of areaList"
                    (mousedown)="selectArea(area)"
                    (input)="isAreaSelected = false">
                    {{ area.area | titlecase }}, {{ area.cityName | titlecase }}
                  </li>
                </ul>
              </div>
            </div>

            <!-- Budget Block -->
            <div class="col-md-3 border-left-custom">
              <label class="field-label">Budget</label>
              <div class="position-relative">
                <input
                  #budgetInput
                  type="text"
                  class="form-control search-input"
                  [(ngModel)]="budgetQuery"
                  (keyup)="onBudgetSearch()"
                  (click)="onBudgetClick()"
                  (blur)="showBudgetSuggestions = false"
                  (focus)="selectclears()"
                  placeholder="Search Budget" />

                <i
                  class="fa fa-wallet location-icon" style="cursor: pointer;"
                  (click)="onIconClick(budgetInput)"></i>

                <ul *ngIf="showBudgetSuggestions" class="suggestion-dropdown">
                  <li
                    *ngFor="let option of filteredBudgetOptions"
                    (mousedown)="selectBudget(option)">
                    {{ option.label }}
                  </li>
                </ul>
              </div>
            </div>

            <!-- Search Button -->
            <div
              class="col-md-2 d-flex justify-content-end align-items-end border-left-custom p-2">

              <button class="btn search-btn btn search-btn w-100"
                (click)="searchArt()"
                [disabled]="!isAreaSelected">Search</button>
            </div>

          </div>
        </div>

      </div>

    </div>

  </div>
  <div class="col-md-12 top-propease" style=" z-index: 0;">

    <div class="col-md-10 mx-auto">
      <div class="d-flex justify-content-between align-items-center mb-2">
        <span class="topproject">Top Property</span>
        <button (click)="navigateTOhome()" class="btn btn-primary viewall">View
          All</button>
      </div>
      <!-- <div class="animation">
        <span class="toppro">Fresh Property Listings Available Here {{showcityname}}</span>
        <span class="toppro">New Homes for Sale</span>
        <span class="toppro">Exclusive Property Deals</span>
    </div> -->
      <div class="animation">
        <span class="toppro">Fresh Property Listings Available Here in
          <strong>{{showcityname}}</strong></span>
        <span class="toppro">New Homes for Sale in
          <strong>{{showcityname}}</strong></span>
        <span class="toppro">Exclusive Property Deals in
          <strong>{{showcityname}}</strong></span>
      </div>

    </div>

    <div class="swiper-container"
      style="display: flex; width: auto !important; cursor: pointer; margin-top: 1pc;">
      <swiper #swiperRef (slideChange)="onSlideChange($event)"
        [slidesPerView]="1" [spaceBetween]="15"
        [navigation]="{ nextEl: '.custom-next-button1',
        prevEl: '.custom-prev-button1' }" [breakpoints]="{
            '768': { 'slidesPerView': 4 }
          }" style="width: 82%;">
        <ng-template swiperSlide *ngFor="let cards of tophome">
          <app-home-top-property (click)="navigateTofullDetail(cards.id)"
            [cardData]="cards">
          </app-home-top-property>
        </ng-template>
      </swiper>

      <div class="custom-prev-button1" (click)="onPrevClick(0)"
        [ngClass]="{'hide': !showPrevButton}">
        <mat-icon
          [ngClass]="{'active': activeButtons[0], 'inactive': !activeButtons[0]}">
          arrow_back
        </mat-icon>
      </div>
      <div class="custom-next-button1" (click)="onNextClick(0)"
        [ngClass]="{'hide': tophome.length <= 3}">
        <mat-icon
          [ngClass]="{'active': activeButtons[0], 'inactive': !activeButtons[0]}">
          arrow_forward
        </mat-icon>
      </div>

    </div>

  </div>

  <div class="col-md-12 " style="margin-top: 3pc; z-index: 0;">

    <div class="col-md-10 mx-auto">
      <div class="d-flex justify-content-between align-items-center mb-2">
        <span class="topproject">Top Projects</span>

        <button (click)="navigateTOListing()"
          class="btn btn-primary viewall">View All</button>
      </div>
      <div class="animation">

        <span class="toppro">Best Developers In <strong>
            {{showcityname}}</strong> To Explore</span>
        <span class="toppro"> Top Programmers in <strong>
            {{showcityname}}</strong> to Watch Out For</span>
        <span class="toppro"> <strong>{{showcityname}}</strong> Best Tech
          Developers to Explore</span>
      </div>
      <!-- </div> -->

    </div>
    <div class="swiper-container"
      style="display: flex; width: auto !important; cursor: pointer;">
      <swiper #swiperRef (slideChange)="onSlideChange($event)"
        [slidesPerView]="1" [spaceBetween]="15"
        [navigation]="{ nextEl: '.custom-next-button1',
        prevEl: '.custom-prev-button1' }" [breakpoints]="{
            '768': { 'slidesPerView': 3 }
          }" style="width: 82%;">
        <ng-template swiperSlide *ngFor="let card of topList">
          <!-- <app-top-property-card (click)="navigateTofullDetail()"
      [cardData]="card"
      [showEditDetailsButton]="false"
      [showViewDetailsButton]="false"
      [showInventoryButton]="false"
      [showEditInventoryButton]="false">
    </app-top-property-card>  -->
          <app-top-property-card (click)="navigateTofullDetail(card.id)"
            [cardData]="card"
            [showEditDetailsButton]="false" [showViewDetailsButton]="false"
            [showInventoryButton]="false"
            [showEditInventoryButton]="false" [showdetails]="false"
            [showdsize]='false'>
          </app-top-property-card>

        </ng-template>
      </swiper>

      <div class="custom-prev-button1" (click)="onPrevClick(0)"
        [ngClass]="{'hide': !showPrevButton}">
        <mat-icon
          [ngClass]="{'active': activeButtons[0], 'inactive': !activeButtons[0]}">
          arrow_back
        </mat-icon>
      </div>
      <div class="custom-next-button1" (click)="onNextClick(0)"
        [ngClass]="{'hide': topList.length <= 3}">
        <mat-icon
          [ngClass]="{'active': activeButtons[0], 'inactive': !activeButtons[0]}">
          arrow_forward
        </mat-icon>
      </div>

    </div>

  </div>

  <div class="col-md-12" style="margin-top: 3pc;">

    <div class="col-md-10 mx-auto">
      <div class="d-flex justify-content-between align-items-center mb-2">
        <span class="topproject">Recently Added</span>
        <button (click)="navigateTOListing1()"
          class="btn btn-primary viewall">View All</button>
      </div>
      <div class="animation">
        <span class="toppro">Based On Preferences Of Users Like You in
          <strong>{{showcityname}}</strong></span>
        <span class="toppro">Chosen By Users With Similar Interests in
          <strong>{{showcityname}}</strong></span>
        <span class="toppro">Tailored To Match Your Preferences in
          <strong>{{showcityname}}</strong></span>
      </div>

    </div>

    <div class="swiper-container"
      style="display: flex; width: auto !important; cursor: pointer; position: relative;">
      <swiper #swiperRef2 [slidesPerView]="1" [spaceBetween]="10"
        [navigation]="{ nextEl: '.custom-next-button2', prevEl: '.custom-prev-button2' }"
        (slideChange)="onSlideChange2($event)" [breakpoints]="{
        '768': { 'slidesPerView': 4 }
      }" style="width: 82%;">
        <ng-template swiperSlide *ngFor="let card of recentList.slice(0,4)">
          <app-top-property-card-small (click)="navigateTofullDetail(card.id)"
            [cardData]="card" [showsizeonly]="false">
          </app-top-property-card-small>

        </ng-template>
      </swiper>

    </div><br>
    <div class="swiper-container"
      style="display: flex; width: auto !important; cursor: pointer; position: relative;">
      <swiper #swiperRef2 [slidesPerView]="1" [spaceBetween]="10"
        [navigation]="{ nextEl: '.custom-next-button2', prevEl: '.custom-prev-button2' }"
        (slideChange)="onSlideChange2($event)" [breakpoints]="{
        '768': { 'slidesPerView': 4 }
      }" style="width: 82%;">
        <ng-template swiperSlide *ngFor="let card of recentList.slice(4)">
          <app-top-property-card-small (click)="navigateTofullDetail(card.id)"
            [cardData]="card" [showsizeonly]="false">
          </app-top-property-card-small>

        </ng-template>
      </swiper>

      <div class="custom-prev-button2" (click)="onPrevClick(1)"
        [ngClass]="{'hide': !showPrevButton2}">
        <mat-icon class="nav-icon">
          arrow_back
        </mat-icon>
      </div>
      <div class="custom-next-button2" (click)="onNextClick(1)"
        [ngClass]="{'hide': recentList.length <= 8}">
        <mat-icon class="nav-icon">
          arrow_forward
        </mat-icon>
      </div>
    </div>

  </div>

  <div class="col-md-12" style="margin-top: 3pc;">

    <div class="col-md-10 mx-auto">
      <div class="d-flex justify-content-between align-items-center mb-2">
        <span class="topproject">Trending Projects</span>
        <button (click)="navigateTOListing2()"
          class="btn btn-primary viewall">View All</button>
      </div>
      <div class="animation">
        <span class="toppro">Most Sought-after Projects In
          <strong>{{showcityname}}</strong></span>
        <span class="toppro">Top Trending Projects Across
          <strong>{{showcityname}}</strong></span>
        <span class="toppro">Highly Acclaimed Projects In
          <strong>{{showcityname}}</strong></span>

      </div>

    </div>
    <div class="swiper-container"
      style="display: flex; width: auto !important; cursor: pointer;">
      <swiper #swiperRef3 [slidesPerView]="1" [spaceBetween]="10"
        [navigation]="{ nextEl: '.custom-next-button3', prevEl: '.custom-prev-button3' }"
        (slideChange)="onSlideChange3($event)" [breakpoints]="{
                '768': { 'slidesPerView': 4 }
              }" style="width: 82%;">
        <ng-template swiperSlide *ngFor="let card of trendingList">
          <app-top-property-card-semi-small
            (click)="navigateTofullDetail(card.id)"
            [cardData]="card"></app-top-property-card-semi-small>
        </ng-template>
      </swiper>

      <div class="custom-prev-button3" (click)="onPrevClick(2)"
        [ngClass]="{'hide': !showPrevButton3}">
        <mat-icon
          [ngClass]="{'active': activeButtons[2], 'inactive': !activeButtons[2]}">
          arrow_back
        </mat-icon>
      </div>
      <div class="custom-next-button3" (click)="onNextClick(2)"
        [ngClass]="{'hide': trendingList.length <= 3}">
        <mat-icon
          [ngClass]="{'active': activeButtons[2], 'inactive': !activeButtons[2]}">
          arrow_forward
        </mat-icon>
      </div>
    </div>
  </div>
  <div *ngIf="showTopIcon" class="top-icon setbutton" (click)="scrollToTop()">
    ⬆
  </div>

  <br>
  <app-footer></app-footer>
</div>
